export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';
export const GET_COUNT_DETAIL = 'GET_COUNT_DETAIL';
export const REMOVE_COUNT_DETAIL ='REMOVE_COUNT_DETAIL'
export const GET_LIST_DETAIL = 'GET_LIST_DETAIL';
export const GET_IMD_CODES ='GET_IMD_CODES';
export const SET_EMPTY_IMD = 'SET_EMPTY_IMD';
export const GET_RELATION_CODES ='GET_RELATION_CODES';
export const SET_EMPTY_RELATION_CODES ='SET_EMPTY_RELATION_CODES';
export const GET_FE_LIST ='GET_FE_LIST';
export const SET_SELECTED_TAB ='SET_SELECTED_TAB';
export const SET_SELECTED_MENU ='SET_SELECTED_MENU';
export const SET_FORM_VALUE ='SET_FORM_VALUE';
export const CLEAR_FORM_VALUE ='CLEAR_FORM_VALUE';
export const AT_WORK ='AT_WORK';
export const NOT_LOGGED_IN ='NOT_LOGGED_IN';
export const GET_CAPACITY_UTILIZATION = 'GET_CAPACITY_UTILIZATION';
export const REMOVE_CAPACITY_UTILIZATION = 'REMOVE_CAPACITY_UTILIZATION';